import { create } from "zustand";
import { persist } from "zustand/middleware";

export const userStore = create(
  persist((set) => ({
    kioskData: null,
    userData: null,
    userMembershipStatus: null,
    setKioskData: (data) => set({ kioskData: data }),
    setUserData: (data) => set({ userData: data }),
    setUserMembershipStatus: (data) => set({ userMembershipStatus: data }),
    clearUserData: () => set({ userData: null, userMembershipStatus: null }),
  })),
  {
    name: "user-storage",
  }
);
// const userStore = create((set) => ({
//   kioskData: {},
//   userData: {},
//   userMembershipStatus: {},
//   setKioskData: (data) => set({ kioskData: data }),
//   setUserData: (data) => set({ userData: data }),
//   setUserMembershipStatus: (data) => set({ userMembershipStatus: data }),
//   clearUserData: () => set({ userData: {}, userMembershipStatus: {} }),
// }));
